import { http } from "@/lib/request";

export interface SupportChatConversation {
  id: number;
  sourceType: "customer" | "coach";
  sourceUserId: number;
  sourceName?: string;
  sourceMobile?: string;
  sourceAvatar?: string;
  status: "open" | "closed";
  lastMessage?: string;
  lastMessageAt?: string;
  userUnreadCount?: number;
  adminUnreadCount?: number;
  createdAt?: string;
  updatedAt?: string;
  closedAt?: string;
}

export interface SupportChatMessage {
  id: number;
  conversationId: number;
  senderType: "user" | "admin" | "system";
  senderId: number;
  senderName?: string;
  contentType: "text";
  content: string;
  clientMsgId?: string;
  createdAt?: string;
  readAt?: string;
}

export interface SupportChatPageResult<T> {
  total: number;
  pageNo: number;
  pageSize: number;
  records: T[];
}

export interface SupportChatEvent {
  type: string;
  conversationId?: number;
  conversation?: SupportChatConversation;
  message?: SupportChatMessage;
}

export interface SupportChatUnreadCount {
  unread_count?: number;
  unreadCount?: number;
}

let openingConversationPromise: Promise<SupportChatConversation> | null = null;

export const supportChatApi = {
  openConversation() {
    if (!openingConversationPromise) {
      openingConversationPromise = http
        .post<SupportChatConversation>("/support-chat/conversation/open")
        .finally(() => {
          openingConversationPromise = null;
        });
    }
    return openingConversationPromise;
  },

  getMessages(params: { conversationId: number; afterMessageId?: number; pageNo?: number; pageSize?: number }) {
    return http.get<SupportChatPageResult<SupportChatMessage>>("/support-chat/messages", { params });
  },

  sendMessage(payload: { conversationId: number; content: string; clientMsgId: string }) {
    return http.post<SupportChatMessage>("/support-chat/messages/send", payload);
  },

  markRead(conversationId: number) {
    return http.post<void>("/support-chat/messages/read", { conversationId });
  },

  getUnreadCount() {
    return http.get<SupportChatUnreadCount>("/support-chat/unread-count");
  },
};
